import moment from 'moment-timezone';

export const GET_NEXT_EARLIEST_DAY = (existingDates, nextTargetYear) => {};

export const DEFAULT_FORMAT = (date) => {
  const parseDate = moment.utc(date);

  return parseDate.isValid() === true ? parseDate.format('MM/DD/YYYY') : '';
};

/**
 * Calculates the run-out reference date based on contract dates and basis.
 *
 * @param {string|Date|moment.Moment} start_date - The contract start date.
 * @param {string|Date|moment.Moment} end_date - The contract end date.
 * @param {string} contract_basis - The contract basis in the format "in/out" (e.g., "12/24").
 * @param {boolean} isStart - If true, returns the run-out start date; otherwise, returns the run-out end date.
 * @returns {moment.Moment|null} The calculated run-out reference date as a moment object, or null if inputs are invalid.
 */
export const getRunOutRefDate = (start_date, end_date, contract_basis, isStart) => {
  if (!start_date || !end_date || !contract_basis) {
    return null;
  }
  const startDate = moment(start_date);
  const endDate = moment(end_date);

  const [parsedIn, parsedOut] = contract_basis.split('/');
  let outMonths = parseFloat(parsedOut);
  const contractPeriod = endDate.diff(startDate, 'months') + 1;
  const extraOutwardMonths = outMonths - contractPeriod;

  // Always parse and operate in UTC
  const utcEndDate = moment.utc(endDate).startOf('day');
  // Start: day after endDate, UTC
  const run_out_start_date = moment.utc(utcEndDate).add(1, 'day').startOf('day');
  console.log('run_out_start_date (UTC):', run_out_start_date.format('YYYY-MM-DD'));

  // End: last day of the last run-out month, UTC
  const run_out_end_date = moment
    .utc(run_out_start_date)
    .add(extraOutwardMonths - 1, 'month')
    .endOf('month')
    .startOf('day');
  console.log('run_out_end_date (UTC):', run_out_end_date.format('YYYY-MM-DD'));
  return isStart ? run_out_start_date : run_out_end_date;
};
